import React from 'react';
import '~sass/OLD/reinvention_styleguide/ui_patterns/vendor_ctas.sass';
import {Typography} from '~library/atoms/Typography';

export const VendorDiscContentVariant = ({iconUrl, vendorName, displayText}) => (
  <div className="vendor-disc-variant">
    <Typography variant="list2" size="large">
      {displayText}
    </Typography>
    <img src={iconUrl} alt={vendorName} />
  </div>
);

export const VendorDiscContent = ({iconUrl, vendorName, displayText}) => (
  <div className="vendor-disc">
    <img src={iconUrl} alt={vendorName} />
    <Typography variant="link" classNames="small">
      {displayText}
    </Typography>
  </div>
);

export const VendorDisc = ({
  disableClick = false,
  registry,
  displayText,
  className = 'vendor-disc__link',
  dataQaId = 'vendor-disc__gifting_link',
  href,
}) => {
  const iconUrl = registry.iconUrl || registry.icon_url;
  const vendorName = registry.vendorName || registry.vendor_name;

  return (
    <a
      href={href || registry?.url || ''}
      target="_blank"
      data-qa-id={dataQaId}
      data-impression-tracking="true"
      data-qa-locator="vendor-disc" // so that the discs have locators without editing data-qa-id
      data-qa-value={vendorName}
      rel="noreferrer"
      className={className}
      onClick={(e) => {
        if (disableClick) {
          e.preventDefault();
          return false;
        }
        return true;
      }}
    >
      <VendorDiscContent iconUrl={iconUrl} vendorName={vendorName} displayText={displayText} />
    </a>
  );
};
